<template>
  <div class="wrapper">
    <UIBlocker :isShow="isGenerating">Aguarde... </UIBlocker>
    <b-row>
      <b-col lg="12"
        ><div class="mb-1">
          <b-button @click="doNovaTarefa" variant="success" size="sm"><i class="fas fa-plus"></i> Adicionar</b-button>
          <b-button
            ref="btnRegerar"
            class="ml-2"
            @click="doShowDtInicio"
            variant="warning"
            size="sm"
            :disabled="isGenerating"
            ><i class="fas fa-sync"></i> Regerar</b-button
          >
          <b-button @click="onShow" variant="success" size="sm" title="Atualizar" class="ml-2"
            ><i class="fas fa-sync"></i> Atualizar Lista</b-button
          >
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <div id="divGantt"></div>
      </b-col>
    </b-row>
    <ModalEditTarefa :wbs="wbs" :registro="tarefaCorrente" :acao="tabela.acaoTarefa" @updatedCronograma="onShow()" />
    <b-modal no-fade id="modal-dt-inicio" title="Informe a Data de Início">
      <date-picker
        input-class="form-control form-control-sm"
        :clearable="false"
        maxlength="10"
        format="DD/MM/YYYY"
        value-type="YYYY-MM-DD"
        v-model="dtInicio"
      ></date-picker>
      <template v-slot:modal-footer>
        <b-button size="sm" @click="doRegerar" variant="primary">
          Regerar
        </b-button>
        <b-button size="sm" @click="() => $bvModal.hide('modal-dt-inicio')">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import * as JSGantt from "jsgantt-improved";
import ModalEditTarefa from "./ModalEditTarefa";
import moment from "moment";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

import axios from "axios";
import { baseApiUrl, showError } from "@/global";

import { bidbus } from "@/main";
import UIBlocker from "@/components/layout/UIBlocker";

export default {
  name: "TabPlanejamento",
  components: { ModalEditTarefa, DatePicker, UIBlocker },
  props: {
    wbs: { type: Object, required: true },
    acao: { type: String, required: true, default: "view" },
  },
  data: function() {
    return {
      dtInicio: moment().format("YYYY-MM-DD"),
      isGenerating: false,
      tarefaCorrente: {},
      tarefas: [],
      tabela: {
        acaoTarefa: "visualizar",
      },
    };
  },
  methods: {
    doShowDtInicio() {
      this.$bvModal.show("modal-dt-inicio");
    },
    doRegerar() {
      this.$bvModal.hide("modal-dt-inicio");
      this.isGenerating = true;
      axios
        .post(`${baseApiUrl}/bid/cronograma/regerar`, {
          programa_id: this.wbs.programa_id,
          wbs_id: this.wbs.wbs_id,
          dt_inicio: this.dtInicio,
        })
        .then(() => {
          this.onShow();
          this.isGenerating = false;
        })
        .catch((err) => {
          this.isGenerating = false;
          showError(err);
        });
    },
    doNovaTarefa() {
      this.tarefaCorrente = {
        registro_id: 0,
        tarefa_id: 0,
        predecessora_id: 0,
        descricao: "",
        dt_inicio: moment().format("YYYY-MM-DD"),
        dt_termino: moment().format("YYYY-MM-DD"),
      };
      this.tabela.acaoTarefa = "incluir";
      this.$nextTick(() => {
        this.$bvModal.show("modal-edit-tarefa");
      });
    },
    doAlterarTarefa(item) {
      let tarefa = this.tarefas.find((f) => f.pID == item);
      this.tarefaCorrente = {
        registro_id: tarefa.pID,
        descricao: tarefa.pName,
        dt_inicio: tarefa.pStart,
        dt_termino: tarefa.pEnd,
        predecessora_id: tarefa.pDepend,
        status_id: tarefa.pStatusID,
        controle_id: tarefa.pControleID,
      };

      this.tabela.acaoTarefa = "alterar";
      this.$nextTick(() => {
        this.$bvModal.show("modal-edit-tarefa");
      });
    },
    doExcluirTarefa(item) {
      this.$bvModal
        .msgBoxConfirm(`Excluir a Tarefa [${item}]?`, {
          noFade: true,
          okTitle: "Excluir",
          cancelTitle: "Cancelar",
          buttonSize: "sm",
          footerClass: "confirm-dialog",
        })
        .then((yesno) => {
          if (yesno) {
            axios
              .delete(`${baseApiUrl}/bid/cronograma/${item}`)
              .then(() => {
                this.onShow();
              })
              .catch((err) => {
                showError(err);
              });
          }
        })
        .catch((err) => {
          showError(err);
          console.log(err);
        });
    },
    onShow() {
      this.doRefresh();
    },
    doRefresh() {
      if (this.wbs && this.wbs.programa_id) {
        if (this.isGenerating == false) this.isGenerating = true;
        let _param = {
          params: {
            programa_id: this.wbs.programa_id,
            wbs_id: this.wbs.wbs_id,
            sintetico: 0,
          },
        };

        axios
          .get(`${baseApiUrl}/bid/cronograma/gantt`, _param)
          .then((resp) => {
            this.tarefas = resp.data;
            this.doMontaGantt(resp.data);
          })
          .catch((err) => {
            this.isGenerating = false;
            console.log(err);
            showError(err);
          });
      }
    },
    doMontaGantt(dados) {
      let g = new JSGantt.GanttChart(document.getElementById("divGantt"), "month");

      g.setOptions({
        vCaptionType: "Complete", // Set to Show Caption : None,Caption,Resource,Duration,Complete,
        vDateTaskDisplayFormat: "day dd month yyyy", // Shown in tool tip box
        vDayMajorDateDisplayFormat: "mon yyyy - Week ww", // Set format to dates in the "Major" header of the "Day" view
        vWeekMinorDateDisplayFormat: "dd mon", // Set format to display dates in the "Minor" header of the "Week" view
        vLang: "pt",
        vShowComp: 0,
        vShowRes: 0,
        vWorkingDays: {
          0: false,
          1: false,
          2: true,
          3: true,
          4: true,
          5: true,
          6: true,
        },
        vScrollTo: "today",
        vShowWeekends: true,
        vShowEndWeekDate: 0, // Show/Hide the date for the last day of the week in header for daily
        vAdditionalHeaders: {
          pStatusDesc: {
            title: "Status",
          },
          pActions: {
            title: "Ações",
          },

          // Add data columns to your table
          // category: {
          //     title: "Category",
          // },
          // sector: {
          //     title: "Sector",
          // },
        },
        vUseSingleCell: 25000, // Set the threshold cell per table row (Helps performance for large data.
        vFormatArr: ["Day", "Week", "Month", "Quarter"], // Even with setUseSingleCell using Hour format on such a large chart can cause issues in some browsers,
        // vEventClickRow: (item) => {
        //     console.log(item.getAllData());

        // }
      });

      dados.forEach((d) => {
        d.pGantt = g;
        g.AddTaskItemObject(d);
      });
      this.isGenerating = false;
      g.setDayColWidth(60);
      g.setWeekColWidth(60);
      g.setMonthColWidth(60);
      g.setUseToolTip(0);
      g.setRowHeight(36);
      g.Draw();
    },
  },
  created() {
    bidbus.$on("insertedWBS", () => {
      this.onShow();
    });
    bidbus.$on("updatedWBS", () => {
      this.onShow();
    });
  },
  mounted() {
    window.doAlterarTarefa = this.doAlterarTarefa;
    window.doExcluirTarefa = this.doExcluirTarefa;

    this.onShow();
  },
};
</script>

<style lang="scss">
.gtasktableh tr,
.gcharttable tr,
.gcharttableh tr,
.gtasktable tr {
  height: 36px !important;
}

// .gchartcontainer{
//     height: calc(100vh - 300px) !important;
// }

.gchartcontainer td {
  font-size: 10px !important;
  font-weight: normal !important;
}

.gchartcontainer td > div {
  font-size: 0.675rem !important;
}

.gselector {
  width: 100% !important;
  max-width: 100% !important;
  //height: 40px !important;
  display: flex;
  align-items: center;

  span {
    padding: 5px;
  }
}

.gselected {
  background-color: #333 !important;
  color: white;
  border-radius: 4px;
}

// #divGanttgcharthead{
//     height: 82px !important;
// }

span.gformlabel:hover {
  border-radius: 4px;
}

.gitemhighlight td {
  background-color: #aaa !important;
}

.gminorheading {
  font-weight: normal !important;
}

.gtaskheading,
.gminorheading {
  background-color: #343a40 !important;
  color: #fff !important;
}

.gtasktableouterwrapper {
  border-right: 2px solid #999 !important;
}

.gmajorheading {
  background-color: #454d55 !important;
  color: white !important;
}

.ggroupblack,
.gtaskblue,
.gtaskred,
.gtaskgreen,
.gtaskyellow,
.gtaskpurple,
.gtaskpink {
  height: 18px !important;
}
// .gmajorheading, .footerdays{
//     height: 41px !important;
// }

// .gtasktableh tr, .gcharttable tr, .gcharttableh tr, .gtasktable tr{
//     height: 41px !important;
// }
</style>
